import highlight from '@/assets/icons/icon-highlight.png';
import { Sound } from '@/classes';
import { keyCodes } from '@/constants/keyCode';
import { useExtendFocusable } from '@/hooks/useExtendFocusable';
import { useFocusElement } from '@/hooks/useFocusElement';
import { focusNearestVisibleContent } from '@/utils';
import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface MenuItemProps {
  title: string;
  path: string;
  icon: React.ReactNode;
  fontSize: string;
  onFocus: () => void;
}

export const MenuItem = ({ fontSize, title, path, icon, onFocus }: MenuItemProps) => {
  const { focused, ref, focusSelf } = useExtendFocusable({
    focusKey: path,
    onFocus: onFocus,
    // 우측 키로 콘텐츠에 진입할 때는 예전 포커스를 복원하지 않고 화면에 보이는 항목으로 이동시킨다.
    onArrowPress: (direction) => (direction === 'right' ? focusNearestVisibleContent() : true),
  });
  const location = useLocation();
  const currentPath = location.pathname.replace('/', '').toLowerCase();
  const isActive = currentPath.includes(path.toLowerCase());
  const handleClick = useCallback(() => {
    Sound.press();
    if (focusSelf) {
      focusSelf();
    }
  }, [focusSelf]);

  useFocusElement({ ref, focused, onClick: () => {}, keyCode: keyCodes.ENTER });
  useEffect(() => {
    if (isActive) {
      focusSelf();
    }
  }, [location, focusSelf, isActive]);

  return (
    <a
      tabIndex={0}
      className={`relative flex flex-col items-center justify-center outline-disable rounded menu-button ${
        isActive ? 'menu-button-active text-black' : ''
      } text-[#969696] focus:text-black hover:text-black ease-in-out duration-300 row-margin-gap-20px`}
      ref={ref}
      onClick={handleClick}
      onContextMenu={handleClick}
      style={{ fontSize: fontSize }}
    >
      {focused && <img src={highlight} className="absolute top-0.5 left-0.5" />}
      {icon}
      <span className="leading-[30px]">{title}</span>
    </a>
  );
};
